import React, { useEffect } from 'react';
import {
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyProgress,
} from '../../../contextsProperty/ContextProperties';
import Commercial from './Commercial';
import Contact from './Contact';
import Location from './Location';
import Area from './Area';
import Property from './Property';
import useLanguage from '../../../../customHooks/useLanguage';

const MainInfo = () => {
    const language = useLanguage();
    const { activeTab } = usePropertyProgress();
    const { getMainInfoSectionData } = usePropertyComplementaryData();
    const { handleFetching } = usePropertyFetching();

    useEffect(() => {
        const getData = async () => {
            handleFetching(true);
            await getMainInfoSectionData();
            handleFetching(false);
        };
        getData();
    }, [language]);

    const getCurrentForm = () => {
        switch (activeTab) {
            case 1:
            default:
                return <Commercial />;
            case 2:
                return <Contact />;
            case 3:
                return <Location />;
            case 4:
                return <Area />;
            case 5:
                return <Property />;
        }
    };

    return <>{getCurrentForm()}</>;
};

export default MainInfo;
